import { Avatar, Box, Container, Paper } from '@mui/material';

import { ReactComponent as KanLogo } from '../../assets/Kan11Logo.svg';
import { useSelector } from 'react-redux';
import { getCurrentUser } from 'store/selectors/user.selector';
import { useEffect, useState } from 'react';

const Header = () => {
	const currentUser = useSelector(getCurrentUser);

	return (
		<Container
			sx={{
				alignContent: 'center',
				textAlign: '-webkit-center',
				direction: 'rtl',
			}}
		>
			<Paper
				sx={{
					width: '70%',
					height: '10vh',
					background:
						'linear-gradient(90deg, #4d4c4c 0%, #f0f0f0 90%, rgba(240, 240, 240, 0) 100%)',
					display: 'flex',
					alignItems: 'center',
				}}
			>
				<Container
					sx={{
						display: 'flex',
						alignItems: 'center',
						justifyContent: 'space-between',
					}}
				>
					{currentUser && (
						<Box sx={{ display: 'flex', alignItems: 'center' }}>
							<Avatar
								sx={{
									margin: '0 5px',
								}}
							/>
							<div style={{ color: 'GrayText' }}>
								{currentUser.firstName} {currentUser.lastName}
							</div>
						</Box>
					)}
					<Box sx={{ textAlign: 'end' }}>
						<KanLogo />
					</Box>
				</Container>
			</Paper>
		</Container>
	);
};

export default Header;
